jQuery(document).ready(function ($) {

  /**
   * Logo Visibility on Scroll
   */
  let isMenuOpen = false;
  const logoFadeThreshold = 100; // pixels from top

  function updateLogoVisibility() {
    const scrollTop = $(window).scrollTop();
    const $logo = $('.site-logo');

    if (isMenuOpen) {
      // Always show logo when menu is open
      $logo.removeClass('hidden');
    } else {
      // Hide logo when scrolled past threshold
      if (scrollTop > logoFadeThreshold) {
        $logo.addClass('hidden');
      } else {
        $logo.removeClass('hidden');
      }
    }
  }

  // Update on scroll
  $(window).on('scroll', updateLogoVisibility);

  // Check on page load in case page is already scrolled
  updateLogoVisibility();

  /**
   * Hamburger Menu Toggle
   */
  $('.hamburger-menu').click(function () {
    $(this).toggleClass('active');
    $('.overlay-menu').toggleClass('active');
    $('body').toggleClass('menu-open');

    // Update ARIA attribute
    const isExpanded = $(this).hasClass('active');
    $(this).attr('aria-expanded', isExpanded);

    isMenuOpen = !isMenuOpen;
    updateLogoVisibility();
  });

  /**
   * Close menu when clicking overlay background
   */
  $('.overlay-menu').click(function (e) {
    if ($(e.target).hasClass('overlay-menu')) {
      $('.hamburger-menu').removeClass('active');
      $('.overlay-menu').removeClass('active');
      $('body').removeClass('menu-open');
      $('.hamburger-menu').attr('aria-expanded', 'false');

      isMenuOpen = false;
      updateLogoVisibility();
    }
  });
  /**
   * Smooth Scroll Hashed Links
   * This will scroll to link on same page
   * Or will smoothly scroll to a hashed section on another page after click
   */

  $(function () {
    // your current click function
    // select all links with hashes, remove if don't link to anything (:not)
    // this is for same page hashed links
    $('a[href*=\\#]:not([href=\\#])').on('click', function () {
      if (!$(this).parents('ul').hasClass('nav-tabs')) {
        var target = $(this.hash);
        // if target.length is 0, set target equal to the name attribuite with hash as value
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        // smooth scroll to the target id
        if (target.length) {
          $('html,body').animate({
            scrollTop: target.offset().top
          }, 1000);
          return false;
        }
      }
    });

    // check if the window location (URL) has a hash in it
    // smoothly scroll to that location
    if (window.location.hash) {
      var target = $(window.location.hash);
      // if target.length is 0, set target equal to the name attribuite with hash as value
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // smooth scroll to the target id
      $('html, body').delay(1000).animate({
        scrollTop: $(target).offset().top + 'px'
      }, 1000);
      return false;
    }

  });


  /**
   * Intersection Observer for Scroll Reveals
   */
  if ('IntersectionObserver' in window) {
    const observerOptions = {
      threshold: 0.15, // Increased for better trigger timing
      rootMargin: '0px 0px -100px 0px' // Trigger earlier for smoother experience
    };

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');

          // Trigger counter animation for stats
          if (entry.target.classList.contains('stat-number')) {
            animateCounter(entry.target);
          }

          // Unobserve after animation triggers to improve performance
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    // Observe all scroll reveal elements
    const scrollRevealElements = document.querySelectorAll('.scroll-reveal, .scroll-reveal-left, .scroll-reveal-right');
    scrollRevealElements.forEach(function (el) {
      observer.observe(el);
    });

    // Observe stat numbers
    const statNumbers = document.querySelectorAll('.stat-number');
    statNumbers.forEach(function (el) {
      observer.observe(el);
    });
  }

  /**
   * Animate Counter for Stats
   */
  function animateCounter(element) {
    if (element.classList.contains('counted')) return;
    element.classList.add('counted');

    const target = parseInt(element.getAttribute('data-target'));
    const duration = 2000;
    const increment = target / (duration / 16);
    let current = 0;

    const updateCounter = function () {
      current += increment;
      if (current < target) {
        element.textContent = Math.floor(current).toLocaleString();
        requestAnimationFrame(updateCounter);
      } else {
        element.textContent = target.toLocaleString();
      }
    };

    requestAnimationFrame(updateCounter);
  }


  /**
   * Reveal job application form section when button is clicked
   */
  $('.career-form-reveal').click(function () {
    $('.career-form-container').toggleClass('d-none');
  });
});
